var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoEnterate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_24",
    "data-name": "Grupo 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.5,
    height: 117.5,
    viewBox: "0 0 117.5 117.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.432,
    y1: -0.454,
    x2: -0.429,
    y2: -0.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(1.958 7.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    "data-name": "Trazado 274",
    d: "M131.35,106.317v70.5H25.6v-70.5a3.928,3.928,0,0,1,3.917-3.917h97.917A3.928,3.928,0,0,1,131.35,106.317Z",
    transform: "translate(-21.683 -86.826)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    "data-name": "Trazado 275",
    d: "M125.475,106.317v70.5H25.6v-70.5a3.928,3.928,0,0,1,3.917-3.917h92.042A3.928,3.928,0,0,1,125.475,106.317Z",
    transform: "translate(-21.683 -86.826)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    "data-name": "Trazado 276",
    d: "M149.816,138.492v64.625H59.733V138.492a1.964,1.964,0,0,1,1.958-1.958h86.167A1.964,1.964,0,0,1,149.816,138.492Z",
    transform: "translate(-47.983 -113.127)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    "data-name": "Trazado 277",
    d: "M143.941,138.492v64.625H59.733V138.492a1.964,1.964,0,0,1,1.958-1.958h80.292A1.964,1.964,0,0,1,143.941,138.492Z",
    transform: "translate(-47.983 -113.127)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    d: "M114.348,252.546l-3.193,3.21a4.5,4.5,0,0,1-6.386,0l-9.579-9.629a4.556,4.556,0,0,1,0-6.419l3.193-3.21Z",
    transform: "translate(-74.284 -190.15)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    d: "M168.11,75.472c-1.018.45-2.135.979-3.349,1.547-5.013,2.311-11.417,5.5-17.8,9.224a1.758,1.758,0,0,1-.2.117,94.316,94.316,0,0,0-18.9,13.787l-.9-.9L108.577,80.759a4.583,4.583,0,0,1-.2-6.208c9.243-10.888,17.507-27.945,21.581-37.091.039-.078.059-.157.1-.235a4.486,4.486,0,0,1,7.3-1.351l5.072,5.092,21.953,22.07,5.053,5.092a4.526,4.526,0,0,1-1.332,7.344Z",
    transform: "translate(-84.606 -34.537)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(22.658 2.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M164.761,86.832a4.668,4.668,0,0,1-1.684,1.292c-4.132,1.86-9.948,4.6-16.117,7.931a1.76,1.76,0,0,1-.2.118,126.948,126.948,0,0,0-19.8,12.886L108.577,90.573a4.583,4.583,0,0,1-.2-6.208c9.243-10.888,17.507-27.945,21.581-37.091a4.456,4.456,0,0,1,2.369,1.253l5.072,5.092,21.953,22.07,5.072,5.092A4.562,4.562,0,0,1,164.761,86.832Z",
    transform: "translate(-107.264 -47.274)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M274.251,70.055,289.895,85.78A11.394,11.394,0,0,0,288.459,71.5,11.248,11.248,0,0,0,274.251,70.055Z",
    transform: "translate(-235.929 -63.378)",
    fill: "#f1eaf4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M224.138,294.155l-2.017,2.037-1.194,1.214a4.49,4.49,0,0,1-6.227.157c-8.636-7.951-14.629-10.477-16.783-11.2a8.284,8.284,0,0,0-.881-.254,80.026,80.026,0,0,1,13.082-10.223,98.015,98.015,0,0,1,13.963,11.789,4.562,4.562,0,0,1,.059,6.482Z",
    transform: "translate(-153.775 -220.497)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M225.08,309.34l-1.195,1.214a4.49,4.49,0,0,1-6.227.157c-8.636-7.951-14.629-10.477-16.783-11.2a96.83,96.83,0,0,1,9.047-6.56A99,99,0,0,1,223.9,304.738,4.609,4.609,0,0,1,225.08,309.34Z",
    transform: "translate(-156.734 -233.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M122.116,428.625v7.833a7.831,7.831,0,0,1-7.833,7.833H16.366a7.831,7.831,0,0,1-7.833-7.833v-7.833a1.964,1.964,0,0,1,1.958-1.958H120.158A1.964,1.964,0,0,1,122.116,428.625Z",
    transform: "translate(-8.533 -336.677)",
    fill: "#7fabfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    "data-name": "Trazado 285",
    d: "M116.241,428.625v7.833a7.831,7.831,0,0,1-7.833,7.833H16.366a7.831,7.831,0,0,1-7.833-7.833v-7.833a1.964,1.964,0,0,1,1.958-1.958H114.283A1.964,1.964,0,0,1,116.241,428.625Z",
    transform: "translate(-8.533 -336.677)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M203.5,434.5H177a3.917,3.917,0,0,1-3.5-2.165l-2.834-5.668h39.167L207,432.335A3.916,3.916,0,0,1,203.5,434.5Z",
    transform: "translate(-133.458 -336.677)",
    fill: "#7fabfa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    "data-name": "Trazado 287",
    d: "M14.409,186.779v-7.833a1.964,1.964,0,0,1,1.958-1.958h1.958v-70.5a3.928,3.928,0,0,1,3.917-3.917H16.367a3.928,3.928,0,0,0-3.917,3.917v70.5H10.492a1.964,1.964,0,0,0-1.958,1.958v7.833a7.831,7.831,0,0,0,7.833,7.833h5.875a7.832,7.832,0,0,1-7.834-7.833Z",
    transform: "translate(-6.576 -79.032)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_288",
    "data-name": "Trazado 288",
    d: "M20.984,119.467v70.5H17.067v-70.5Z",
    transform: "translate(-13.15 -92.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_289",
    "data-name": "Trazado 289",
    d: "M155.738,65.962a6.518,6.518,0,0,0-1.79-5.785l-7.2-7.234a13.366,13.366,0,0,0-2.456-15.306,13.218,13.218,0,0,0-15.238-2.479l-7.187-7.224a6.45,6.45,0,0,0-10.486,1.93C107.319,39.014,99.135,55.972,90,66.717a6.5,6.5,0,0,0-.752,7.415L87.236,76.15a6.519,6.519,0,0,0,0,9.182l9.577,9.63a6.421,6.421,0,0,0,4.582,1.906h0a6.415,6.415,0,0,0,4.58-1.907l1.8-1.814,1.8,1.814c.013.013.032.018.045.031a1.963,1.963,0,0,0,.53.356c.057.026.115.043.175.064a1.93,1.93,0,0,0,.237.086c.065.013,6.445,1.483,16.736,10.984a6.374,6.374,0,0,0,4.339,1.7,6.474,6.474,0,0,0,4.6-1.926l3.224-3.241a6.517,6.517,0,0,0-.084-9.266A127.826,127.826,0,0,0,127.6,83.435a218.523,218.523,0,0,1,24.425-12.744A6.473,6.473,0,0,0,155.738,65.962Zm-23.731-27.84a9.335,9.335,0,0,1,9.511,2.277,9.464,9.464,0,0,1,2.272,9.568l-6.127-6.158ZM103.2,92.2a2.527,2.527,0,0,1-1.8.752h0A2.531,2.531,0,0,1,99.59,92.2l-9.577-9.63a2.6,2.6,0,0,1,0-3.656l1.8-1.813,13.2,13.27Zm20.857-6.494a110.324,110.324,0,0,1,12.609,10.86,2.6,2.6,0,0,1,.031,3.688l-3.224,3.241a2.516,2.516,0,0,1-3.505.109,58.659,58.659,0,0,0-15.333-10.774c.228-.2.472-.4.706-.607a87.433,87.433,0,0,1,8.717-6.517Zm27.828-20.456a2.52,2.52,0,0,1-1.465,1.869,199.031,199.031,0,0,0-31.1,17.088q-.29.2-.574.406c-2.185,1.558-4.253,3.161-6.142,4.8-.235.2-.457.4-.684.607-.3.271-.623.54-.917.814L93.073,72.807h0a2.6,2.6,0,0,1-.094-3.55c9.459-11.122,17.833-28.458,21.983-37.8a2.51,2.51,0,0,1,1.859-1.474,2.628,2.628,0,0,1,.47-.043,2.519,2.519,0,0,1,1.8.76L142.1,53.82l.854.859h0l8.218,8.26a2.57,2.57,0,0,1,.715,2.31Z",
    transform: "translate(-65.76 -20.048)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    "data-name": "Trazado 290",
    d: "M370.235,24.369l3.917-3.917a1.958,1.958,0,0,0-2.769-2.769L367.466,21.6a1.958,1.958,0,1,0,2.769,2.769Z",
    transform: "translate(-282.684 -13.193)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_291",
    "data-name": "Trazado 291",
    d: "M294.051,5.875V1.958a1.958,1.958,0,1,0-3.917,0V5.875a1.958,1.958,0,1,0,3.917,0Z",
    transform: "translate(-223.551)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_292",
    "data-name": "Trazado 292",
    d: "M20.983,99.743a1.96,1.96,0,0,1,1.958-1.958h23.5a1.958,1.958,0,1,0,0-3.917h-23.5a5.881,5.881,0,0,0-5.875,5.875v7.833a1.958,1.958,0,0,0,3.917,0V99.743Z",
    transform: "translate(-13.149 -72.326)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_293",
    "data-name": "Trazado 293",
    d: "M19.815,179.356a1.236,1.236,0,0,0-.353-.117,2.863,2.863,0,0,0-.391-.039,2.056,2.056,0,0,0-1.39.568,1.931,1.931,0,0,0,.646,3.192,1.957,1.957,0,0,0,.745.157,2.063,2.063,0,0,0,1.39-.568,1.986,1.986,0,0,0,0-2.781l-.294-.235A1.506,1.506,0,0,0,19.815,179.356Z",
    transform: "translate(-13.196 -138.075)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_294",
    "data-name": "Trazado 294",
    d: "M113.583,168.283V99.742a5.881,5.881,0,0,0-5.875-5.875H88.125a1.958,1.958,0,0,0,0,3.917h19.583a1.96,1.96,0,0,1,1.958,1.958v68.542H105.75V105.617a3.921,3.921,0,0,0-3.917-3.917H88.125a1.958,1.958,0,0,0,0,3.917h13.708v62.667H15.667V105.617h11.75a1.958,1.958,0,0,0,0-3.917H15.667a3.921,3.921,0,0,0-3.917,3.917v62.667H7.833V123.242a1.958,1.958,0,0,0-3.917,0v45.042A3.921,3.921,0,0,0,0,172.2v7.833a9.8,9.8,0,0,0,9.792,9.792h97.917a9.8,9.8,0,0,0,9.792-9.792V172.2A3.922,3.922,0,0,0,113.583,168.283ZM75.164,172.2l-1.417,2.834A1.95,1.95,0,0,1,72,176.117H45.5a1.95,1.95,0,0,1-1.752-1.083L42.335,172.2Zm32.544,13.708H9.792a5.881,5.881,0,0,1-5.875-5.875H25.458a1.958,1.958,0,1,0,0-3.917H3.917V172.2H37.956l2.293,4.586a5.844,5.844,0,0,0,5.255,3.247H72a5.844,5.844,0,0,0,5.255-3.247l2.293-4.586h34.039v3.917H92.042a1.958,1.958,0,1,0,0,3.917h21.542A5.882,5.882,0,0,1,107.708,185.908Z",
    transform: "translate(0 -72.325)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_295",
    "data-name": "Trazado 295",
    d: "M140.451,452.267h-1.958a1.958,1.958,0,1,0,0,3.917h1.958a1.958,1.958,0,0,0,0-3.917Z",
    transform: "translate(-105.201 -348.475)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_296",
    "data-name": "Trazado 296",
    d: "M353.784,452.267h-1.958a1.958,1.958,0,1,0,0,3.917h1.958a1.958,1.958,0,0,0,0-3.917Z",
    transform: "translate(-269.575 -348.475)",
    fill: "#264ecc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoEnterate);
export default __webpack_public_path__ + "static/media/icono-enterate.c3031ddc8c9c01cf667b623624e32c0f.svg";
export { ForwardRef as ReactComponent };